import {
	Configuration,
	GetServiceRequest,
	ServiceApi,
	ServizioDto,
	UpdateServiceRequest,
} from "@api/client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApiConfig } from "core/store";
import getConfiguration, { decodeError, errorHandler } from "core/store/config";

enum ServiceReducer {
	getService = "[SERVICE] Get Service",
	updateService = "[SERVICE] Update Service",
}

export const serviceGetService = createAsyncThunk<
	ServizioDto | undefined,
	void,
	ThunkApiConfig
>(ServiceReducer.getService, async (_, { dispatch, extra, getState }) => {
	try {
		let pratica = getState().pratica;

		if (!pratica?.idPratica) return;

		let request: GetServiceRequest = {
			idPratica: pratica.idPratica,
		};

		return await new ServiceApi(
			getConfiguration(Configuration, extra, getState)
		).getService(request);
	} catch (e) {
		errorHandler(e, dispatch);
	}
});

export const serviceUpdateService = createAsyncThunk<
	ServizioDto | undefined,
	ServizioDto,
	ThunkApiConfig
>(
	ServiceReducer.updateService,
	async (request, { dispatch, extra, getState }) => {
		try {
			let _request: UpdateServiceRequest = {
				servizioDto: request,
			};

			return await new ServiceApi(
				getConfiguration(Configuration, extra, getState)
			).updateService(_request);
		} catch (e: any) {
			if ((e as any)?.response?.status === 400) {
				const decodeErrors = await decodeError(e.response);
				throw decodeErrors.message;
			} else errorHandler(e, dispatch);
		}
	});
